import { Lead } from "@kanda-libs/ks-frontend-services";

export const getLeadName = (lead: Lead): string =>
  [
    lead.lead_applicant?.customer_details.first_name,
    lead.lead_applicant?.customer_details.last_name,
  ]
    .filter(Boolean)
    .join(" ");
